'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserKind() {
}
export { $c_Lapp_data_UserKind as $c_Lapp_data_UserKind };
$p = $c_Lapp_data_UserKind.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserKind;
/** @constructor */
function $h_Lapp_data_UserKind() {
}
export { $h_Lapp_data_UserKind as $h_Lapp_data_UserKind };
$h_Lapp_data_UserKind.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_data_UserKind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fS)));
}
export { $isArrayOf_Lapp_data_UserKind as $isArrayOf_Lapp_data_UserKind };
//# sourceMappingURL=app.data.-User-Kind.js.map
